<template>
    <div>
        <el-breadcrumb separator=">" class="bread">
            <el-breadcrumb-item :to="{ name: 'deviceManager' }">设备管理</el-breadcrumb-item>
            <el-breadcrumb-item>修改设备</el-breadcrumb-item>
        </el-breadcrumb>
        <div>
            <el-form :model="deviceForm" :rules="devicerules" ref="deviceForm"
                     class="demo-ruleForm" >

                <el-form-item  label="设备编号" prop="deviceId">
                    <el-input v-model="deviceForm.deviceId" disabled placeholder="设备编号" style="width: auto;"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" prop="deviceName">
                    <el-input v-model="deviceForm.deviceName" clearable placeholder="设备名称" style="width: auto;"></el-input>
                </el-form-item>
                <el-form-item label="机构信息" prop="orgId">
                    <el-select v-model="deviceForm.orgId" clearable placeholder="机构信息">
                        <el-option v-for="(item,index) in orgList" :label="item.org_name" :value="item.org_id">{{item.org_name}}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备地址" prop="address">
                    <el-input v-model="deviceForm.address" clearable placeholder="设备地址" style="width: 30%;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="submitForm('deviceForm')"
                               id="primary">确 定</el-button>
                    <el-button @click="cancelSubmit()">取 消</el-button>
                </el-form-item>
            </el-form>

        </div>
    </div>
</template>
<script>
    import moment  from 'moment'
    //    import { product, productUpdate, categoryProduct } from '@/assets/api.js'
    export  default{
        data(){
            var validateName = (rule, value, callback) => {
                if (this.deviceForm.deviceName=='' ) {
                    callback(new Error('请输入设备名称'));
                }else {
                    var params={deviceName:this.deviceForm.deviceName, id:this.deviceForm.id,Token:this.token}
                    this.$http.post(this.validateNameUrl,params).then((response)=>{
                        var data=response.body;
                        if(data.Code=="200") {
                            callback();
                        }else if(data.Code=='400'){
                            callback(new Error('设备名称已存在，请重新输入'));
                        }
                    },()=>{
                        callback(new Error('网络异常'));
                    })
                }
            };

            return{
                url:this.deviceHost+this.updateDeviceUrl,
                validateIdUrl:this.deviceHost+this.validateDeviceIdUrl,
                validateNameUrl:this.deviceHost+this.validateDeviceNameUrl,
                isorno:true,
                isShow:false,
                isexpSecond:false,
                resourceType:"",
                labelposition:"left",
                prodindex:0,
                orgList:[],
                deviceForm:{
                    deviceId:'',
                    deviceName:'',
                    orgId:'',
                    address:'',
                    id:0
                },
                token:'123123123123',
                products:[],
                isorginit:'1',
                devicerules: {
                    deviceId: [
                        { required: true, message: '请输入机器编号', trigger: 'blur' },
                        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
                    ],
                    deviceName: [
                        { required: true, message: '请输入设备名称', trigger: 'blur' },
                        /*{ validator: validateactName, trigger: 'blur' },*/
                        { min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' },
                        { validator: validateName, trigger: 'blur' },
                    ],
                    address: [
                        { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
                    ]
                }
            }
        },
        created(){
            this.getOrgList();
            this.getDeviceInfo();
        },
        methods:{
            getDeviceInfo(){
                this.$http.get(this.deviceHost+this.findDeviceUrl+"?id="+this.$route.query.id+"&tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                            console.log(response.body)
                            if (response.body.Code === '200') {
                                console.log(response.body.Data);
                                var deviceInfo = response.body.Data;
                                this.deviceForm.deviceId = deviceInfo.deviceId;
                                this.deviceForm.deviceName = deviceInfo.deviceName;
                                this.deviceForm.orgId = deviceInfo.orgId;
                                this.deviceForm.address = deviceInfo.address;
                                this.deviceForm.id=deviceInfo.id;
                            }
                        }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            cancelSubmit(){
                this.$router.push({
                    path: "deviceManager"
                });
            },
            getOrgList(){
                this.$http.get(this.deviceHost+"/vueFeign/findOrgList?tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.orgList = response.body.Data;
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            submitForm(formName) {
//                console.log(this.$refs.formName);
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var params={id:this.deviceForm.id,deviceName:this.deviceForm.deviceName,orgId:this.deviceForm.orgId,
                            address:this.deviceForm.address,tenantId:this.getcookie('storeId'),Token:this.token}
                        this.$http.post(this.url,params).then((response)=>{
                            var data=response.body;
                            if(data.Code=="200") {
                                this.$message({showClose: true, message: '修改成功', type: 'success'});
                                this.$router.push({path: "deviceManager"})
                            }else if(data.Code == "51103"||data.Code == "500"){
                                this.$message({showClose: true,message: data.Meta ,type: 'error'});
                            }else{
                                this.$message({showClose: true,message: '参数错误',type: 'error'});
                            }
                        },()=>{
                            this.$message({showClose: true,message: '网络异常',type: 'error'});
                        })
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            clear(name) {
                this.$refs[name].clearFiles();
            },
            export2Excel() {
                var codeList= [{name:'001',status:0},{name:'002',status:0},{name:'003',status:0}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../../vendor/Export2Excel');
                    const tHeader = ['优惠券码','优惠券状态'];
                    const filterVal = ['name','status'];
                    const list = codeList;
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '提货码列表');
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
        }
    }
</script>
<style>
    .isable{
        display:none;
    }
    .demo-ruleForm{

        margin: 30px auto 0 auto;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// modifyDevice.vue?54e54aa6